<template>
    <v-container grid-list-lg class="mt-7">
        <v-layout row wrap v-if="loadingCategories">
            <v-flex xs12 sm6 lg3 v-for="n in 3" :key="n">
                <v-skeleton-loader type="card"></v-skeleton-loader>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex xs12 sm6 md6 lg3 v-for="product in allProducts" :key="product.id">
                <v-card flat>
                    <v-img
                            class="cursor-pointer"
                            :aspect-ratio="1/1"
                            :src="getProductImage(product.imageData)"
                            @click="$router.push('/product/' + product.alias)"
                    >
                    </v-img>
                    <v-card-text class="pt-6 px-0 text-center">
                        <div class="cursor-pointer">
                            <h3 class="font-weight-light primary--text mb-2" @click="$router.push('/product/' + product.alias)">{{ product.name }}</h3>
                            <div class="mb-5">
                                <strong>{{product.amountWithVat}} Kč</strong>
                            </div>
                        </div>
                        <v-btn outlined small color="primary" rounded @click="addToCart({product: product, qty: 1})">Přidat do košíku</v-btn>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import {getProductImage} from '../../Helper'
    import {mapGetters, mapActions} from 'vuex'

    export default {
        name: 'Products',
        mixins: [getProductImage],
        computed: {
            ...mapGetters([
                'allProducts',
                'loadingCategories'
            ])
        },
        methods: {
            ...mapActions([
                'addToCart'
            ])
        }
    }
</script>

<style>
    .cursor-pointer {
        cursor: pointer;
    }
</style>
